import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	lightPurple: {
		id: 'issue-table-conditional-formatting.common.utils.formatting-colors.light-purple',
		defaultMessage: 'Subtle purple',
		description: 'Aria-label for subtle purple color button',
	},
	lightBlue: {
		id: 'issue-table-conditional-formatting.common.utils.formatting-colors.light-blue',
		defaultMessage: 'Subtle blue',
		description: 'Aria-label for subtle blue color button',
	},
	lightGreen: {
		id: 'issue-table-conditional-formatting.common.utils.formatting-colors.light-green',
		defaultMessage: 'Subtle green',
		description: 'Aria-label for subtle green color button',
	},
	lightTeal: {
		id: 'issue-table-conditional-formatting.common.utils.formatting-colors.light-teal',
		defaultMessage: 'Subtle teal',
		description: 'Aria-label for subtle teal color button',
	},
	lightYellow: {
		id: 'issue-table-conditional-formatting.common.utils.formatting-colors.light-yellow',
		defaultMessage: 'Subtle yellow',
		description: 'Aria-label for subtle yellow color button',
	},
	lightRed: {
		id: 'issue-table-conditional-formatting.common.utils.formatting-colors.light-red',
		defaultMessage: 'Subtle red',
		description: 'Aria-label for subtle red color button',
	},
	lightGray: {
		id: 'issue-table-conditional-formatting.common.utils.formatting-colors.light-gray',
		defaultMessage: 'Subtle gray',
		description: 'Aria-label for subtle gray color button',
	},
	purple: {
		id: 'issue-table-conditional-formatting.common.utils.formatting-colors.purple',
		defaultMessage: 'Bold purple',
		description: 'Aria-label for purple color button',
	},
	blue: {
		id: 'issue-table-conditional-formatting.common.utils.formatting-colors.blue',
		defaultMessage: 'Bold blue',
		description: 'Aria-label for blue color button',
	},
	green: {
		id: 'issue-table-conditional-formatting.common.utils.formatting-colors.green',
		defaultMessage: 'Bold green',
		description: 'Aria-label for green color button',
	},
	teal: {
		id: 'issue-table-conditional-formatting.common.utils.formatting-colors.teal',
		defaultMessage: 'Bold teal',
		description: 'Aria-label for teal color button',
	},
	yellow: {
		id: 'issue-table-conditional-formatting.common.utils.formatting-colors.yellow',
		defaultMessage: 'Bold yellow',
		description: 'Aria-label for yellow color button',
	},
	red: {
		id: 'issue-table-conditional-formatting.common.utils.formatting-colors.red',
		defaultMessage: 'Bold red',
		description: 'Aria-label for red color button',
	},
	gray: {
		id: 'issue-table-conditional-formatting.common.utils.formatting-colors.gray',
		defaultMessage: 'Bold gray',
		description: 'Aria-label for gray color button',
	},
});
